import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GatewayService } from "../api/gateway.service";

/** Arguments identifying which user session an admin wants to revoke. */
export interface AdminRevokeSessionParams {
    userId: number;
    sessionId: string;
}

/** State and action returned by {@link useAdminRevokeSession}. */
export interface UseAdminRevokeSessionReturn {
    /** Revoke the targeted user session; resolves once the request completes. */
    revoke: (params: AdminRevokeSessionParams) => Promise<unknown>;
    loading: boolean;
    error: Error | null;
}

/** Admin action: revoke one device session of a given user (instant logout of it). */
export const useAdminRevokeSession = (): UseAdminRevokeSessionReturn => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: ({ userId, sessionId }: AdminRevokeSessionParams) =>
            GatewayService.adminRevokeUserSession(userId, sessionId),
        onSuccess: (_data, { userId }) => {
            queryClient.invalidateQueries({ queryKey: ["gateway", "user-sessions", userId] });
        },
    });
    return {
        revoke: (params) => mutation.mutateAsync(params),
        loading: mutation.isPending,
        error: mutation.error,
    };
};
